module.exports = __webpack_public_path__ + "4709413a5e888c362f85c581d65d3036.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/user.png
// module id = 350
// module chunks = 0